import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography,
  IconButton
} from '@mui/material';
import { Close as CloseIcon, DeleteForever as DeleteIcon } from '@mui/icons-material';
import { t } from '../../utils/textUtils';

/**
 * Componente reutilizable para diálogos de confirmación de eliminación.
 * 
 * @param {boolean} open - Estado de apertura del diálogo.
 * @param {function} onClose - Función a llamar cuando se cierra el diálogo.
 * @param {function} onConfirm - Función a llamar cuando se confirma la eliminación.
 * @param {string} title - Título del diálogo.
 * @param {string} content - Mensaje de confirmación.
 * @param {string} confirmButtonText - Texto del botón de confirmación (por defecto "Eliminar").
 * @param {string} cancelButtonText - Texto del botón de cancelación (por defecto "Cancelar").
 */
const DeleteConfirmationDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = t('KONFIRMASI PENGHAPUSAN'), 
  content = t('APAKAH ANDA YAKIN INGIN MENGHAPUS ITEM INI? TINDAKAN INI TIDAK DAPAT DIBATALKAN.'),
  confirmButtonText = t('HAPUS'),
  cancelButtonText = t('BATAL')
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          bgcolor: '#FFF8E1', 
          color: '#5D4037', 
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2
        }}
      >
        <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center' }}>
          <DeleteIcon sx={{ mr: 1, color: '#FF7043' }} />
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: '#5D4037' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ p: 3 }}>
        <Typography variant="body1">{content}</Typography>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, bgcolor: '#FAFAFA' }}>
        <Button 
          onClick={onClose}
          sx={{ color: '#5D4037' }}
        >
          {cancelButtonText}
        </Button>
        <Button 
          onClick={onConfirm}
          variant="contained" 
          color="error"
          sx={{ bgcolor: '#FF7043', '&:hover': { bgcolor: '#FF5722' } }}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog; 